import React from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PowerSettingsNewOutlinedIcon from '@mui/icons-material/PowerSettingsNewOutlined';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import { RowAction } from './DocumentsBlock';
import { attachmentsLabel, formatDate, requestValidityInfo, usageLabel } from './documentFormat';
import styles from './InsuranceDocumentsSection.module.css';

/**
 * Um pedido médico: título, quem pediu e emissão; vencimento (com o selo
 * "Vencido", "Vence hoje" ou "Vence em breve");
 * anexos e em quantos atendimentos foi usado; ações compactas.
 */
function MedicalRequestRow({ request, busy, onEdit, onToggle, onAttachments }) {
  const inactive = request.active === 0 || request.active === false;
  const validity = requestValidityInfo(request.valid_until, request.expired);
  const secondary = [
    request.requesting_professional ? `Pedido por ${request.requesting_professional}` : '',
    request.issued_at ? `emitido em ${formatDate(request.issued_at)}` : '',
  ].filter(Boolean).join(' · ');

  return (
    <li className={`${styles.row} ${inactive ? styles.muted : ''}`}>
      <span className={`${styles.rowIcon} ${inactive ? styles.rowIconMuted : ''}`}>
        <DescriptionOutlinedIcon fontSize="small" />
      </span>

      <div className={styles.identity}>
        <span className={styles.tags}>
          <span className={`${styles.name} ${styles.ellipsis}`} title={request.title}>{request.title}</span>
          {inactive && <span className={`${styles.tag} ${styles.tagInactive}`}>Inativo</span>}
          {!inactive && validity.badge && (
            <span className={`${styles.tag} ${validity.expired ? styles.tagExpired : styles.tagExpiring}`}>{validity.badge}</span>
          )}
        </span>
        <span className={`${styles.secondary} ${styles.ellipsis}`} title={secondary || undefined}>
          {secondary || 'Sem quem pediu informado'}
        </span>
      </div>

      <div className={styles.side}>
        <span
          className={`${styles.detail} ${validity.tone === 'muted' ? styles.detailMuted : ''} ${validity.expired ? styles.detailExpired : ''}`}
        >
          <EventAvailableOutlinedIcon className={styles.detailIcon} />
          {validity.label}
        </span>
        <span className={styles.counters}>
          <button type="button" className={styles.counterLink} onClick={() => onAttachments(request)}>
            <AttachFileOutlinedIcon />
            {attachmentsLabel(request.attachments_count)}
          </button>
          <span>{usageLabel(request.linked_count, false)}</span>
        </span>
      </div>

      <span className={styles.actions}>
        <RowAction title="Anexos" label={`Anexos de ${request.title}`} disabled={busy} onClick={() => onAttachments(request)} Icon={AttachFileOutlinedIcon} />
        <RowAction title="Editar pedido" label={`Editar ${request.title}`} disabled={busy} onClick={() => onEdit(request)} Icon={EditOutlinedIcon} />
        {inactive ? (
          <RowAction title="Reativar pedido" label={`Reativar ${request.title}`} disabled={busy} onClick={() => onToggle(request)} Icon={RestoreOutlinedIcon} tone="positive" />
        ) : (
          <RowAction title="Inativar pedido" label={`Inativar ${request.title}`} disabled={busy} onClick={() => onToggle(request)} Icon={PowerSettingsNewOutlinedIcon} tone="warning" />
        )}
      </span>
    </li>
  );
}

export default MedicalRequestRow;
